import constate from 'constate';

import { useComment } from './useComment';

export const [CommentProvider, useCommentContext] = constate(useComment);
